import {Component, Input, OnInit, ViewChild} from "@angular/core";
import {EmpresaService} from "../../services/empresa.service";
import {MonitoradorPedidos} from "../../fidelidade/MonitoradorPedidos";

@Component({
  selector: 'app-form-integracao-keeta',
  templateUrl: './form-integracao-keeta.component.html',
  styleUrls: ['./form-integracao-keeta.component.scss']
})
export class FormIntegracaoKeetaComponent implements OnInit {
  @ViewChild('frm', {}) frm:  any;
  @Input() empresa: any;
  @Input() integracaoKeeta: any;
  @Input() userCode: any = {};
  mensagemErro: string;
  salvando: boolean;
  confirmarRemover: boolean;
  confirmarDesativar: boolean;
  sincronizando: boolean;
  removendo: boolean;
  ativando: boolean;
  gerandoLink: any;
  urlAtivacao: string;
  redirecionando = false;
  idLojaManual = '';
  appInfo: any = {}
  AVAILABLE = 'AVAILABLE'
  UNAVAILABLE = 'UNAVAILABLE'
  constructor(private  empresaService: EmpresaService, public monitoradorPedidos: MonitoradorPedidos) { }

  ngOnInit(): void {
    if(this.integracaoKeeta && this.integracaoKeeta.userCode)
      this.userCode = this.integracaoKeeta.userCode;


    if(this.integracaoKeeta.lojasAtivar && this.integracaoKeeta.lojasAtivar.length)
       this.integracaoKeeta.lojaSelecionada =     this.integracaoKeeta.lojasAtivar[0]
    this.empresaService.obtenhaAppInfo().then((appInfo: any) => {
       this.appInfo = appInfo;
    });

    // atualizar status das lojas Keeta para exibir botão abrir/fechar
    try{ this.monitoradorPedidos.autalizeStatusKeeta(); }catch(e){}
  }

  copiarAppId() {
    if (this.appInfo.id) {
      navigator.clipboard.writeText(this.appInfo.id).then(() => {
        // Opcional: mostrar uma mensagem de sucesso
        console.log('ID copiado para a área de transferência');
      }).catch(err => {
        console.error('Erro ao copiar ID:', err);
      });
    }
  }

  onSubmit () {
    if (this.frm.valid) {
      this.salvando = true;
    }
  }

  gereLinkAutorizacao(){
    if(!this.urlAtivacao){
      this.gerandoLink =  true;
      this.empresaService.gereLinkAtivacaoKeeta().then((urlAtivacao: any) => {
        this.urlAtivacao = urlAtivacao;
        this.gerandoLink = false;
        this.abraLinkAtivacao();
      }).catch( (erro) => {
        this.mensagemErro = erro;
        this.gerandoLink = false
      })
    } else {
      this.abraLinkAtivacao();
    }

    return false;
  }

  ativeManualmenteLoja(){
    if(this.idLojaManual){
      this.autorizeNovaLoja({idLoja: this.idLojaManual})
    } else {
      this.mensagemErro = 'Informa o id da Loja que deseja integrar'
    }
  }

  ativeLojaSelecionada() {
    if (!this.integracaoKeeta.lojaSelecionada) {
      this.mensagemErro = 'Selecione uma loja para continuar';
      return;
    }

    // Criar objeto de integração com os dados da loja selecionada
    const integracaoData = {
      idLoja: this.integracaoKeeta.lojaSelecionada.id,
      nomeLoja: this.integracaoKeeta.lojaSelecionada.name,
      authId: this.integracaoKeeta.authId
    };

    this.autorizeNovaLoja(integracaoData)
  }

  autorizeNovaLoja(integracaoData: any){
    this.ativando = true;
    this.mensagemErro = null;
    this.empresaService.confirmeIntegracaoLojaKeeta(integracaoData).then((integracao: any) => {
      this.ativando = false;
      this.integracaoKeeta = integracao;
      this.empresaService.sincronizeFormasPagamentoKeeta().then(() => {})
      setTimeout(() => {
        window.location.reload();
      }, 1500)
    }).catch((erro) => {
      this.ativando = false;
      this.mensagemErro = erro.message || erro;
    });
  }

  abraLinkAtivacao(){
    this.redirecionando = true;
    let janela = window.open(this.urlAtivacao)

    if(!janela){
      this.mensagemErro = 'Janela foi bloqueada, vetifique e tente de novo'
    }
  }

  removerIntegracao() {
    this.removendo = true;

    this.empresaService.removaIntegracaoKeeta(this.integracaoKeeta).then(  () => {
      this.removendo = false;
      this.integracaoKeeta.removida = true;
      this.integracaoKeeta = null;
    }).catch((erro) => {
      this.removendo = false;
      alert(erro)
    })
  }

  abrirLojaKeeta(){
    this.ativando = true;
    this.empresaService.abrirLojaKeeta().then(() => {
      this.ativando = false;
      const info: any = this.infoLojaKeeta();
      if(info) info.status = this.AVAILABLE
      window.setTimeout(() => this.recarregueStatusKeeta(), 800);
    }).catch((erro) => {
      this.ativando = false;
      this.mensagemErro = erro?.message || erro;
    })
  }

  fecharLojaKeeta(){
    this.ativando = true;
    this.empresaService.fecharLojaKeeta().then(() => {
      this.ativando = false;
      const info: any = this.infoLojaKeeta();
      if(info) info.status = this.UNAVAILABLE
      window.setTimeout(() => this.recarregueStatusKeeta(), 800);
    }).catch((erro) => {
      this.ativando = false;
      this.mensagemErro = erro?.message || erro;
    })
  }

  private recarregueStatusKeeta(){
    try{ window.location.reload(); }catch(e){}
  }

  confirmeRemover(){
    this.confirmarRemover = true;
  }


  confirmeDesativar(){
    this.confirmarDesativar = true;
  }

  editarIntegracao(integracao: any){
    integracao.editar = true;
  }

  desativarIntegracao() {

    this.removendo = true;

    this.empresaService.desativeIntegracaoIfood(this.integracaoKeeta).then(  () => {
      this.removendo = false;
      this.confirmarDesativar = false;
      this.integracaoKeeta.desativado = true;
    }).catch((erro) => {
      this.removendo = false;
      alert(erro)
    })
  }

  ativeIntegracao(){
    this.ativando  = true;

    this.empresaService.ativeIntegracaoIfood(this.integracaoKeeta).then(  () => {
      this.ativando = false;
      this.integracaoKeeta.desativado = false;
    }).catch((erro) => {
      this.removendo = false;
      alert(erro)
    })
  }

  canceleRemover() {
    this.confirmarRemover = false;
    this.confirmarDesativar = false;
  }

  fecharAlerta(){
    this.mensagemErro = null
  }

  // utilitários de status a partir do monitoradorPedidos.lojasKeeta
  infoLojaKeeta(){
    try{
      if(!this.integracaoKeeta) return null;
      const id = this.integracaoKeeta.idLoja.toString();

      return (this.monitoradorPedidos?.lojasKeeta || []).find((l: any) => (l.id || '').toString() === id);
    }catch(e){ return null }
  }

  estaAbertaKeeta(){
    const info: any = this.infoLojaKeeta();
    return info ? !!info.aberta : null;
  }

  statusKeeta(){
    const info: any = this.infoLojaKeeta();
    return info ? info.status : null;
  }


}
